export const workspace = {
  routes: [
    {
      path: "/workspace/library/accessor",
      component: () => import("../workspace-library-accessor-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
